/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import './ConnectTab/ConnectTab.scss';

interface IToastNotification {
  title: string;
  description: string;
}

export const ToastNotification = ({
  title,
  description
}: IToastNotification) => {
  return (
    <div className="notificationEMaas">
      <div className="notificationEMaasIcon">
        <img
          className="notificationIcon"
          src={require('../../images/IconaccountLimit.svg')}
        />
      </div>
      <div className="notificationEMaasContent">
        <div className="notificationEMaasContent-top">
          <div className="notificationEMaasHeading">
            <span className="notificationEMaasTitle">{title}</span>
          </div>
        </div>
        <div className="notificationEMaasMessage">
          <div>{description}</div>
        </div>
      </div>
    </div>
  );
};
